<template>
    <li class="mb-2">
        <div class="-ml-7 p-2 pl-7 relative"
             :class="{'border-blue': itemIsSelected, 'hover:cursor-pointer': !read_only}"
             @click="() => $emit('item_selected', item)"
        >
            <div v-if="item.time && !item.is_private"
                 class="absolute border -right-16 top-4 text-[10px] rounded text-center py-0.5 text-gray-700 z-10 border-gray-200  hidden md:block"
                 :class="{'bg-gray-200 px-2': level === 0, 'bg-white px-1': level > 0}"
            >
                {{ displayTime }}
            </div>

            <div class="gap-2">
                <div class="block md:flex justify-between items-start whitespace-normal w-full">
                    <div class="font-medium hyphens-auto break-words text-wrap w-full md:w-[calc(100%-150px)]">{{ item.text }}</div>

                    <div class="flex flex-col items-start text-left min-w-0 md:min-w-[150px]">
                        <ul v-if="item.people_responsible && item.people_responsible.length" class="list-none pl-0" :class="item.is_private ? 'hidden' : ''">
                            <li
                                v-for="person in item.people_responsible"
                                class="text-sm text-gray-800"
                            >
                                {{ person.name }}
                            </li>
                        </ul>
                    </div>
                </div>

                <span v-if="!read_only && item.user_notes && item.user_notes.length && !include_user_notes" class="text-gray-600 ml-2">
                    <i class="fa-solid fa-notebook"></i>
                    <span v-text="item.user_notes.length"></span>
                </span>
                <div v-if="item.description && !item.is_private" v-html="item.description" class="text-sm text-gray-800 mt-4 break-words overflow-hidden"></div>
                <AttachmentsList
                    v-if="item.uploads.length && !no_docs && !item.is_private"
                    :attachments="item.uploads"
                    class="mt-4" context="agenda"
                    :inline="true"
                    :meeting="meeting"
                ></AttachmentsList>
                <div v-if="!read_only && include_user_notes && item.user_notes.length" class="bg-yellow-soft px-4 py-3 flex rounded-lg">
                    <div class="mr-3">
                        <i class="fa-regular fa-note"></i>
                    </div>
                    <div>
                        <div class="font-medium mb-2">My Notes</div>
                        <div v-for="note in item.user_notes" v-html="note.text" class="text-sm"></div>
                    </div>
                </div>
                <div v-if="item.motion">
                    <div v-for="motion in item.motion" >
                        <div v-if="motion.motion_is_public" class="bg-gray-200 mt-5 p-5 rounded-md w-full">
                            <p class="mb-4">{{ motion.motion_text }}</p>
                            <p class="mb-4">
                                <span class="font-medium">Moved by:</span> {{ motion.motion_moved_by }}<br />
                                <span class="font-medium">Seconded by:</span> {{ motion.motion_seconded_by }}<br />
                                <span class="font-medium">Outcome:</span> {{ motion.motion_decision }}<br />
                            </p>
                            <p>{{ formattedVotes(motion.votes) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AgendaListView
            v-if="item.agenda.length"
            :items="item.agenda"
            :selected_item="selected_item"
            @item_selected="(i) => $emit('item_selected', i)"
            :level="level+1"
            :ignore_thumbnails="ignore_thumbnails"
            :include_user_notes="include_user_notes"
            :no_docs="no_docs"
            :read_only="read_only"
            :meeting="meeting"
        ></AgendaListView>
    </li>
</template>

<script>

import AvatarGroup from "~/components/ui/AvatarGroup.vue";
import AttachmentsListShowCondensed from "~/components/agenda/AttachmentsListShowCondensed.vue";
import AttachmentsList from "~/components/agenda/AttachmentsList.vue";

export default {
    name: "AgendaListItem",
    components: { AttachmentsListShowCondensed, AvatarGroup, AttachmentsList },
    props: ['item', 'selected_item', 'level', 'ignore_thumbnails', 'include_user_notes', 'no_docs', 'read_only', 'meeting'],
    methods: {
        formattedVotes(motionVotes) {
            return Object.values(motionVotes || {})
                .filter(v => v?.motion_vote_vote)
                .map(v => `${v.motion_vote_user} (${v.motion_vote_vote})`)
                .join(', ')
        }
    },
    computed: {
        itemIsSelected() {
            return this.selected_item && this.selected_item.id === this.item.id;
        },
        displayTime() {
            return this.item.time;
        },
    }
}

</script>
